<template>
    <div class="led-content">
        <div class="row">
            <span class="label" :class="{ 'is-required': required }">说明</span>
            <div class="field">
                <TextRefSelect :model-value="content" type="led_status" :texts="texts"
                    :default-placeholder="required ? '默认说明：请选择' : '默认说明：不使用（App 按文案 key 用本地翻译）'"
                    @update:model-value="onContentChange"></TextRefSelect>
                <div class="tip">
                    同一方案在不同场景下文案不同时，可「添加条件文案」：内置条件为已绑定、主账号，也可自定义变量
                    （App 不认识的条件会被忽略）。
                </div>
            </div>
        </div>
        <div class="row">
            <span class="label">按钮</span>
            <div class="field field-inline">
                <el-select :model-value="action || ''" size="small" class="action"
                    @update:model-value="onActionChange">
                    <el-option v-for="a in actionOptions" :key="a.code" :label="a.label" :value="a.code"></el-option>
                </el-select>
                <span class="tip">显示在说明下方，按钮文案在「字典管理 → 灯效按钮」配置</span>
            </div>
        </div>
        <div v-if="error" class="error-tip">{{ error }}</div>
    </div>
</template>

<script>
import TextRefSelect from './TextRefSelect.vue'
import { textRefDefault, validateTextRef } from './utils'

// 方案/灯效预设里的一条灯效说明：说明文案（支持按场景加条件文案）+ 说明下方的按钮
export default {
    name: 'PairingLedContentField',
    components: { TextRefSelect },
    props: {
        content: { type: [String, Object], default: '' },
        action: { type: String, default: '' },
        // 文案用途 led_status 的文案列表；不传时 TextRefSelect 自己加载
        texts: { type: Array, default: null },
        // 说明是否必填：方案里必填，灯效预设可空（App 按文案 key 用本地翻译）
        required: { type: Boolean, default: true },
        // 灯效按钮字典 meta.led_actions：{ code, name/value, text }
        actions: { type: Array, default: () => [] },
    },
    emits: ['update:content', 'update:action'],
    computed: {
        // 按钮下拉来自字典 type=led_action：code 为行为，name 为后台显示名
        actionOptions() {
            const options = [{ code: '', label: '无' }]
            this.actions.forEach((a) => {
                const code = a.value || a.code || ''
                if (code) options.push({ code, label: a.label && a.label !== code ? a.label : (a.name || code) })
            })
            return options
        },
        error() {
            if (this.required && !textRefDefault(this.content)) {
                return '请选择说明'
            }
            return validateTextRef(this.content, this.required ? '说明' : '')
        },
    },
    methods: {
        onContentChange(v) {
            this.$emit('update:content', v === undefined ? '' : v)
        },
        onActionChange(v) {
            this.$emit('update:action', v || '')
        },
    },
}
</script>

<style scoped>
.led-content {
    width: 100%;
}

.row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
}

.label {
    flex: none;
    width: 64px;
    font-size: 12px;
    line-height: 28px;
    color: #606266;
}

.label.is-required::before {
    content: '*';
    color: #f56c6c;
    margin-right: 2px;
}

.field {
    flex: 1;
    min-width: 0;
}

.field-inline {
    display: flex;
    align-items: center;
    gap: 8px;
}

.action {
    width: 160px;
}

.tip {
    margin-top: 2px;
    font-size: 12px;
    line-height: 18px;
    color: #909399;
}

.error-tip {
    font-size: 12px;
    color: #f56c6c;
}
</style>
